import camelCase from 'lodash/camelCase';
import { matchPath } from 'react-router-dom';
import { IBreadcrumbItem } from 'dash-ui';

import { RoutesPath } from 'flow-components/routes/routes';
import { useGetOrganizationByIdLazyQuery } from 'gql/generated.graphql';
import {
  IBreadcrumbScopeBuildHookParams,
  IBreadcrumbScopeBuildParams,
} from 'common/hooks/use-breadcrumb-builder/breadcrumbs-scope-builders/';
import { DEFAULT_ORGANIZATION_TAB_KEY } from 'pages/organizations/OrganizationDetailsPage/components/OrganizationDetailsTabs/OrganizationDetailsTabs.constants';

export const useOrganizationsBreadcrumbBuilder = (): [
  IBreadcrumbScopeBuildHookParams
] => {
  const [getOrganizationById] = useGetOrganizationByIdLazyQuery();

  return [
    async ({ pathname, t, currentTab }: IBreadcrumbScopeBuildParams) => {
      const items: IBreadcrumbItem[] = [];

      const organizationParams = matchPath(
        RoutesPath.OrganizationDetails,
        pathname
      );

      // home breadcrumb to organizations list
      items.push({
        icon: 'suitcase',
        label: t`organizations`,
        path: RoutesPath.Organizations,
      });

      const organizationId = organizationParams?.params?.id;

      if (organizationId) {
        const organizationPath = RoutesPath.OrganizationDetails.replace(
          ':id',
          organizationId
        );
        const { data } = await getOrganizationById({
          variables: { organizationId },
        });
        const { name } = data?.getOrganizationById || {};

        // add organization name as breadcrumb
        if (name) {
          items.push({ label: name, path: organizationPath });
        }

        if (currentTab && currentTab !== DEFAULT_ORGANIZATION_TAB_KEY) {
          // add organization tab as breadcrumb
          items.push({
            label: t(camelCase(currentTab)),
            path: `${organizationPath}?tab=${currentTab}`,
          });
        }
      }
      return items;
    },
  ];
};
